

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux'; // You can replace with your state management library
import Cookies from 'js-cookie';
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './containers/Home'
import Login from './containers/Login'
import Layout from './components/Layout'
import Register from './containers/Register'
import Dashboard from './containers/AdminDashboard/Dashboard'
import Bhajans from './containers/Bhajans'
import About from './containers/About'
import Gallery from './containers/Gallery'
import Contact from './containers/Contact'
import Events from './containers/Events'
import BhajanInDetail from './containers/Bhajans/bhajanInDetail';
import VoiceRecognition from './containers/Examples/VoiceRecognition';
import ImageTextRecognition from './containers/Examples/ImageTextRecognition';
import Verifyotp from './containers/Register/verifyotp';
import VerifyOtpSuccess from './containers/Register/verifyOtpSuccess';
import Forgetpass from './containers/Login/forgetpass';
import ResetPassword from './containers/Login/resetPassword';
import NotFound from './containers/NotFound/404-notfound';
import MainHeader from './components/Header/MainHeader';
import CreateEvent from './containers/AdminDashboard/CreateEvent';
import EventDetail from './containers/Events/EventDetail';
import RequireAuth from './features/auth/RequireAuth';
import PersistLogin from './features/auth/PersistLogin';
import Prefetch from './features/auth/Prefetch';
import Welcome from './features/auth/Welcome';
import UsersList from './features/users/UsersList';
import EditUser from './features/users/EditUser';
import NewUserForm from './features/users/NewUserForm';
import { ROLES } from './config/roles'
import EventList from './features/events/EventList';
import EditEvent from './features/events/EditEvent';
import NewEvent from './features/events/NewEvent';
import BhajanList from './features/bhajans/BhajanList';
import NewBhajan from './features/bhajans/NewBhajan';
import EditBhajan from './features/bhajans/EditBhajan';
import FileUploadComponent from './features/events/FileUploadComponent';
import Videos from './containers/Videos';

import NewQuote from './features/quotes/NewQuote';
import EditQuote from './features/quotes/EditQuote';
import QuoteList from './features/quotes/QuoteList';

import MeditationList from './features/meditation/MeditationList';
import NewMeditation from './features/meditation/NewMeditation';
import EditMeditation from './features/meditation/EditMeditation';

import CarouselListScreen from './features/carousel/screens/CarouselListScreen'; // नया
import CarouselNewScreen from './features/carousel/screens/CarouselNewScreen';   // नया
import CarouselEditScreen from './features/carousel/screens/CarouselEditScreen';

// Category Imports (existing)
// ✅ Renamed for clarity to match screen components
import CategoryListScreen from './features/categories/CategoryList'; // Assuming CategoryList.js is the list screen
import CategoryNewScreen from './features/categories/NewCategory';    // Assuming NewCategory.js is the new screen
import CategoryEditScreen from './features/categories/EditCategory';  // Assuming EditCategory.js is the edit screen

import ContentList from './features/contents/ContentList'; // <--- NEW IMPORT
import EditContent from './features/contents/EditContent'; // <--- हम इसे आगे बनाएंगे
import NewContent from './features/contents/NewContent'; // <--- हम इसे आगे बनाएंगे
import PrivacyPolicy from './containers/Privacy-Terms/index';
import TermsAndConditions from './containers/Privacy-Terms/TermsAndConditions';
import DeleteAccount from './containers/Privacy-Terms/DeleteAccount';


import GalleryImageList from './features/galleryImages/GalleryImageList';
import NewGalleryImage from './features/galleryImages/NewGalleryImage';
import EditGalleryImage from './features/galleryImages/EditGalleryImage';

import GalleryCategoryList from './features/galleryCategories/GalleryCategoryList';
import NewGalleryCategory from './features/galleryCategories/NewGalleryCategory';
import EditGalleryCategory from './features/galleryCategories/EditGalleryCategory';

import GalleryEventList from "./features/galleryEvents/GalleryEventList";
import NewGalleryEvent from "./features/galleryEvents/NewGalleryEvent";
import EditGalleryEvent from "./features/galleryEvents/EditGalleryEvent";
import BulkUploadGalleryImages from "./features/galleryImages/BulkUploadGalleryImages"
const App = () => {

  // Get a cookie
  

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* public routes */}
        <Route index element={<Home />} />
        <Route path="login" element={<Login />} />

        {/* protected routes */}
        {/* <Route element={<RequireAuth />}>
          <Route path="welcome" element={<Welcome />} />
          <Route path="userslist" element={<UsersList />} />
        </Route> */}

    
        {/* public routes */}
        <Route index element={<About />} />
        <Route
          exact path="about"
          element={<About />}
        />
        <Route
          exact path="upload"
          element={<FileUploadComponent />}
        />
        <Route
          exact path="gallery"
          element={<Gallery />}
        />
        <Route
          exact path="contact"
          element={<Contact />}
        />
        <Route
          exact path="videos"
          element={<Videos />}
        />
        <Route
          exact path="events"
          element={<Events />}
        />
        <Route
          exact path="events/:id"
          element={<EventDetail />}
        />
        <Route
          exact path="registration"
          element={<Register />}
        />

        <Route
          exact path="verifyregistration"
          element={<Verifyotp />}
        />
       <Route
          exact path="verifysuccess"
          element={<VerifyOtpSuccess />}
        />
       
        

        <Route exact path="forgotpassword"
          element={<Forgetpass /> } />

      <Route exact path="reset-password/:token"
          element={<ResetPassword /> } />

        {/* Protected route - Redirect to login if not authenticated */}
        

        {/* Other public or unprotected routes */}
        <Route
          exact path="bhajans"
          element={<Bhajans />}
        />
        <Route
          exact path="bhajans/:id"
          element={<BhajanInDetail />}
        />
        {/* <Route exact path="/about" element={<AboutPage />} /> */}
        
    
       <Route path="/privacy-policy" element={<PrivacyPolicy />} />
       <Route path="/termsnconditions" element={<TermsAndConditions />} />
       <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="error" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/error" />} /> {/* Redirect all unknown routes to /error */}

        {/* Protected Routes */}
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth  allowedRoles={[...Object.values(ROLES)]} />}>
            <Route element={<Prefetch />}>
              <Route path="dashboard" element={<Dashboard />}>

                <Route index element={<Welcome />} />

                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="users">
                    <Route index element={<UsersList />} />
                    <Route path=":id" element={<EditUser />} />
                    <Route path="new" element={<NewUserForm />} />
                  </Route>
                </Route>
                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="events">
                    <Route index element={<EventList />} />
                    <Route path=":id" element={<EditEvent />} />
                    <Route path="new" element={<NewEvent />} />
                  </Route>
                </Route>

                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="bhajans">
                    <Route index element={<BhajanList />} />
                    <Route path=":id" element={<EditBhajan />} />
                    <Route path="new" element={<NewBhajan />} />
                  </Route>
                </Route>

                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="quotes">
                    <Route index element={<QuoteList />} />
                    <Route path=":id" element={<EditQuote />} />
                    <Route path="new" element={<NewQuote />} />
                  </Route>
                </Route>
                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="meditation">
                    <Route index element={<MeditationList />} />
                    <Route path=":id" element={<EditMeditation />} />
                    <Route path="new" element={<NewMeditation />} />
                  </Route>
                </Route>
                 {/* कैरोसेल रूट्स - नए जोड़े गए */}
                 <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="carousel">
                    <Route index element={<CarouselListScreen />} />
                    <Route path=":id" element={<CarouselEditScreen />} />
                    <Route path="new" element={<CarouselNewScreen />} />
                  </Route>
                </Route>

                {/* ✅ Category Routes - Moved inside a dedicated RequireAuth for Admin/Manager */}
                {/* As per your example for carousel, these should also be protected */}
                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="categories">
                    <Route index element={<CategoryListScreen />} />
                    <Route path=":id" element={<CategoryEditScreen />} />
                    <Route path="new" element={<CategoryNewScreen />} />
                  </Route>
                </Route>

                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="contents">
                    <Route index element={<ContentList />} />
                    <Route path=":id" element={<EditContent />} />
                    <Route path="new" element={<NewContent />} />
                  </Route>
                </Route>


                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="gallery">
                    <Route index element={<GalleryImageList />} />
                    <Route path="new" element={<NewGalleryImage />} />
                    <Route path=":id" element={<EditGalleryImage />} />
                    <Route path="bulk-upload" element={<BulkUploadGalleryImages />}
/>
                  </Route>
                </Route>
                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="gallery-categories">
                    <Route index element={<GalleryCategoryList />} />
                    <Route path="new" element={<NewGalleryCategory />} />
                    <Route path=":id" element={<EditGalleryCategory />} />
                  </Route>
                </Route>

                <Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
                  <Route path="gallery-events">
                    <Route index element={<GalleryEventList />} />
                    <Route path="new" element={<NewGalleryEvent />} />
                    <Route path=":id" element={<EditGalleryEvent />} />
                  </Route>
                </Route>
                {/* Content Routes (future) */}
                {/* <Route path="content">
                  <Route index element={<ContentList />} />
                  <Route path="new" element={<NewContent />} />
                  <Route path=":id" element={<EditContent />} />
                </Route> */}

               

              </Route>{/* End Dash */}
            </Route>
          </Route>
        </Route>
        

      </Route>
    </Routes>
  );
};

export default App;
